export const trimStart = (source: string, chars: string): string =>
  commonLoop(
    source,
    chars,
    (source, testChar) => testChar === source.slice(0, 1),
    (source) => source.slice(1),
  )

export const trimEnd = (source: string, chars: string): string =>
  commonLoop(
    source,
    chars,
    (source, testChar) => testChar === source.slice(-1),
    (source) => source.slice(0, -1),
  )

const commonLoop = (
  source: string,
  chars: string,
  testCurrentChar: (source: string, testChar: string) => boolean,
  updateSource: (source: string) => string,
): string => {
  while (source.length > 0) {
    let found = false
    for (let i = 0; i < chars.length; i++) {
      const testChar = chars.charAt(i)
      if (testCurrentChar(source, testChar)) {
        source = updateSource(source)
        found = true
        break
      }
    }
    if (!found) {
      return source
    }
  }
  return source
}
